import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "description", "logo", "href", "target", "onClick", "tags", "disabled", "className", "layoutType", "outline"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { RichText } from '@sbercloud/uikit-product-site-rich-text';
import { TagSpecial } from '@sbercloud/uikit-product-site-tag';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { Card } from '@snack-uikit/card';
import { Typography } from '@snack-uikit/typography';
import { useCardInteractions } from '../../hooks';
import { getTypographySize } from '../utils';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export function CardCase(_ref) {
  var _rest$dataTestId, _logo$alt;
  var title = _ref.title,
    description = _ref.description,
    logo = _ref.logo,
    href = _ref.href,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_blank' : _ref$target,
    onClick = _ref.onClick,
    tags = _ref.tags,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    className = _ref.className,
    layoutType = _ref.layoutType,
    outline = _ref.outline,
    rest = _objectWithoutProperties(_ref, _excluded);
  var dataTestId = (_rest$dataTestId = rest['data-test-id']) !== null && _rest$dataTestId !== void 0 ? _rest$dataTestId : 'card-case';
  var _useCardInteractions = useCardInteractions({
      href: href,
      disabled: disabled,
      onClick: onClick
    }),
    anchorRef = _useCardInteractions.anchorRef,
    handleLinkClick = _useCardInteractions.handleLinkClick,
    handleCardClick = _useCardInteractions.handleCardClick,
    handleCardKeyDown = _useCardInteractions.handleCardKeyDown;
  return /*#__PURE__*/_jsx(Card, _objectSpread(_objectSpread({}, extractSupportProps(rest)), {}, {
    size: "m",
    className: cn(styles.card, className),
    disabled: disabled,
    onClick: handleCardClick,
    onKeyDown: handleCardKeyDown,
    "data-test-id": dataTestId,
    outline: outline,
    children: /*#__PURE__*/_jsxs("div", {
      "data-layout-type": layoutType,
      className: styles.wrapper,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.header,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.title,
          children: [/*#__PURE__*/_jsx(Typography, {
            tag: "h3",
            family: "sans",
            purpose: "title",
            size: getTypographySize(layoutType),
            className: styles.title,
            "data-test-id": "".concat(dataTestId, "__title"),
            children: href ? /*#__PURE__*/_jsx("a", {
              tabIndex: -1,
              ref: anchorRef,
              href: href,
              target: target,
              onClick: handleLinkClick,
              "data-test-id": "".concat(dataTestId, "__title-link"),
              children: title
            }) : title
          }), tags && tags.length > 0 && /*#__PURE__*/_jsx("div", {
            className: styles.tagRow,
            children: tags.map(function (tag, index) {
              return /*#__PURE__*/_createElement(TagSpecial, _objectSpread(_objectSpread({
                "data-test-id": "".concat(dataTestId, "__tag")
              }, tag), {}, {
                key: index
              }));
            })
          })]
        }), /*#__PURE__*/_jsx("img", {
          className: styles.logo,
          alt: (_logo$alt = logo.alt) !== null && _logo$alt !== void 0 ? _logo$alt : title,
          src: logo.src,
          "data-test-id": "".concat(dataTestId, "__logo")
        })]
      }), description && /*#__PURE__*/_jsx(RichText, {
        className: styles.description,
        richText: description,
        "data-test-id": "".concat(dataTestId, "__description")
      })]
    })
  }));
}